$(document).ready(function () {
  $('.teaser .btn-read-more').on('click', function(){
  	$(this).closest('.teaser').hide();
    $(this).closest('.teaser').siblings('.fulltext').fadeIn(400);
  });
  
  $('.fulltext .btn-read-less').on('click', function(){
  	$(this).closest('.fulltext').hide();
    $(this).closest('.fulltext').siblings('.teaser').fadeIn(400);
  });
  
  if ($('.template-index').length) {
  	var windowWidth = $( window ).width();
    if (windowWidth < 768) {
      var parentElement = $('.main-page-content').children().eq(2);
      console.log(parentElement.find('.gallery__item-2'));
      parentElement.find('.gallery__item-2').insertBefore(parentElement.find('.gallery__item-1'));
    }
  }
  
  $( window ).resize(function() {
    if ($('.template-index').length) {
      var windowWidth = $( window ).width();
      if (windowWidth < 768) {
        var parentElement = $('.main-page-content').children().eq(2);
        console.log(parentElement.find('.gallery__item-2'));
        parentElement.find('.gallery__item-2').insertBefore(parentElement.find('.gallery__item-1'));
      }
    }
    
    /*if ($('#shopify-section-story2-template').length) {
      var windowWidth = $( window ).width();
      if (windowWidth < 768) {
        var firstParagraph = $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(1)').text();
        var secondParagraph = $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(2)').text();
        var aggregatedParagraph = '<p><em>' + firstParagraph + ' ' + secondParagraph + '</em></p>';
        $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(1)').html(aggregatedParagraph);
        $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(2)').css('display', 'none');
      }
    }*/
  });
  
  if ($('#shopify-section-story2-template').length) {
    var windowWidth = $( window ).width();
    if (windowWidth < 768) {
      var firstParagraph = $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(1)').text();
      var secondParagraph = $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(2)').text();
      var aggregatedParagraph = '<p><em>' + firstParagraph + ' ' + secondParagraph + '</em></p>';
      $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(1)').html(aggregatedParagraph);
      $('#shopify-section-story2-template .section-rich-text .rte p:nth-child(2)').css('display', 'none');
    }
  }
  
});